import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/key-highlight', { params });
  },
  detail(id) {
    return axios.get(`/v1/key-highlight/detail/${id}`);
  },
  create(data) {
    return axios.post('/v1/key-highlight', data);
  },
  update(id, params) {
    return axios.put(`/v1/key-highlight/update/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/key-highlight/delete/${id}`);
  },
  getActive(params = {}) {
    return axios.get('/v1/key-highlight/active', { params });
  },
  geSystemtActive(params = {}) {
    return axios.get('/v1/key-highlight-system', { params });
  }
};
